/* ------------------------ style ------------------------ */
import style from "./style.module.scss";

/* ------------------------ plugin ------------------------ */
import clsx from "clsx";
import styled from "styled-components";
import React, { useRef, useEffect } from "react";
import dynamic from "next/dynamic";

/* ------------------------ type ------------------------ */
import type { ResourceListItem } from "@/components/previewResource/index-type";

/* ------------------------ components ------------------------ */
const CDNImage = dynamic(() => import("@/components/cdnImage/cdnImage"), { ssr: false });

/* ------------------------ assets ------------------------ */
import PlayLittleIcon from "@/images/icon/play-little-icon.png";

/* ------------------------ utils ------------------------ */
import { useTranslation } from "@/i18n/client";

const PlayerTagIcon = styled.div`
  width: 47px;
  height: 17px;
  line-height: 17px;
  border-radius: 2px;
  color: #fff;
  font-size: 10px;
  padding-left: 14px;
  padding-right: 6px;
  position: absolute;
  top: 4px;
  left: 6px;
  background: rgba(0, 0, 0, 0.25) url("${PlayLittleIcon.src}") no-repeat 6px 5px;
  background-size: 6px 8px;
`

const ResourceWidth = 64;
const ResourceHeight = 64;

interface PropsType {
  resourceList: ResourceListItem[];
  currentIndex: number;
  changeIndexHandler?: (index: number) => void;
}

const BottomResourceList: React.FC<PropsType> = ({
  resourceList = [],
  currentIndex = 0,
  changeIndexHandler
}) => {
  const { t } = useTranslation();
  const resourceListBoxRef = useRef<HTMLDivElement>(null);
  const resourceListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!resourceListBoxRef.current) return;

    const currentSelectedItem = resourceListRef.current?.children[currentIndex];
    const currentSelectedItemRect = currentSelectedItem?.getBoundingClientRect();
    const resourceListBoxRect = resourceListBoxRef.current?.getBoundingClientRect();
    const resourceListBoxScrollLeft = resourceListBoxRef.current?.scrollLeft;

    currentSelectedItemRect && (
      resourceListBoxRef.current.scrollLeft =
      currentSelectedItemRect?.left -
      resourceListBoxRect?.left +
      resourceListBoxScrollLeft
    );
  }, [currentIndex])

  const handleClick = (index: number) => {
    changeIndexHandler && changeIndexHandler(index);
  }

  return (
    <div className={style.bottom_resource_list_box} ref={resourceListBoxRef}>
      <div className={style.bottom_resource_list} ref={resourceListRef}>
        {
          resourceList.map((item: ResourceListItem, index: number) => {
            return (
              <div key={index} className={clsx(style.resource_item, currentIndex === index && style.active)}>
                {
                  item.type == "video" ?
                    item.coverImageUrl ?
                      <>
                        <PlayerTagIcon>{t('previewResource.video')}</PlayerTagIcon>

                        <CDNImage
                          className={style.image}
                          src={item.coverImageUrl}
                          width={ResourceWidth}
                          height={ResourceHeight}
                          onClick={() => handleClick(index)}
                        />
                      </>
                      :
                      null :
                    <CDNImage
                      className={style.image}
                      src={item.url}
                      width={ResourceWidth}
                      height={ResourceHeight}
                      onClick={() => handleClick(index)}
                    />
                }
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default BottomResourceList;